import styles from "./navbar-item.module.css";
import { MyIcons } from "../../icons/my-icons";

const NavbarItem = ({ name, icon, filledIcon, isActive, isExpanded }) => {
  return (
    <div
      className={`${styles.general} ${isActive ? styles.active : styles.inactive} ${!isExpanded && styles.noExpanded}`}
    >
    
      <MyIcons height={24} width={24} name={isActive ? filledIcon : icon} color={isActive ? "var(--white)" : "var(--dark-grey)"}/>
   
      {!!isExpanded && <span
        className={styles.name}
        style={{ color: isActive ? "var(--white)" : "var(--dark-grey)" }}
      >
        {name}
      </span>}
    </div>
  );
};

export default NavbarItem;